import { useStaticQuery, graphql } from "gatsby";

export const useData = () => {
  const data = useStaticQuery(graphql`
    query SiteQuery {
      site {
        siteMetadata {
          title
        }
      }
      allImages: allPrismicImage {
        nodes {
          prismicId
          data {
            title
            description {
              html
            }
            image {
              fluid(maxWidth: 500, maxHeight: 500) {
                ...GatsbyPrismicImageFluid_noBase64
              }
              fixed(width: 500, height: 500) {
                ...GatsbyPrismicImageFixed_noBase64
              }
            }
            constellations {
              constellation {
                prismicId: id
                slug
              }
            }
          }
        }
      }
      allConstellations: allPrismicTag {
        nodes {
          prismicId
          data {
            title
            description {
              html
            }
            colour
          }
        }
      }
    }
  `);
  return data;
};
